import {makeStyles} from '@material-ui/core/styles';


export const useStyles = makeStyles(() => ({
  tableRoot: {
    minWidth: '650px',
    '& .MuiTableCell-root': {
      color: '#6B7177',
      borderBottom: '1px solid #ebeaea',
      padding: '2px 13px',
      fontSize: '12px',
      '& div:first-child': {
        '@media screen and (max-width: 960px)': {
          fontWeight: 'bold'
        }
      }
    },
    '& .MuiTableCell-head': {
      padding: '0 13px',
      fontWeight: 'bold',
      '& .MuiButton-text': {
        color: '#6B7177',
        fontWeight: 'bold',
        padding: '5px'
      }
    },
    '& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root': {
      borderBottom: 'none'
    }
  }
}));
